import React, { useState, useEffect, useRef } from 'react';
import loaderIcon from '../../assets/images/icons/loader.gif';
import pptIcon from '../../assets/images/icons/ppt.svg';
import deleteIcon from '../../assets/images/icons/trash.svg';
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import zoneInfoIcon from '../../assets/images/icons/zone-info.svg';
import googleImg from '../../assets/images/google-img.svg';
import copyIcon from '../../assets/images/icons/copy.svg';
import { Col, Row, Input, Radio, Space, Select, Switch, Modal, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { default as ReactSelect } from 'react-select';
import { Link } from 'react-router-dom';
import tagRomoveIcon from '../../assets/images/icons/tag_close_icon.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import filterIcon from '../../assets/images/icons/filter.svg';
import HoverCloseIcon from '../../assets/images/icons/hover_close.svg';



// const { TabPane } = Tabs;
const items = [
    {
        key: '1',
        tab: 'URL Template',
        content: (
            <>
                <div className='d-flex justify-content-between'>
                    <label className='form_label'>URL</label>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div>
                <div className="select_item">
                    <div className="primary text">
                        http://vid-rtb.xapads.com/rtb?zone=225098
                    </div>
                </div>
                <div className='adding_new_parameters'>
                    <div className='d-flex align-items-start justify-content-between'>
                        <label className='form_label'>Parameters</label>
                        <small className='info_text--d2-orange'>*All parameters should be URL-encoded</small>
                    </div>
                </div>
                <div className='all_parameters--text'>
                    <ul className='m-0 p-0'>
                        <li>
                            <h4 className='parameters_heading'>subid</h4>
                            <span className='parameters_text'>Up to 128 alphanumeric and special characters is allowed: [0-9A-Za-z._-]. The zone is allowed to have up to 2,000 distinct subids per day. You will be able to view statistics for each subid.</span>
                        </li>
                        <li>
                            <h4 className='parameters_heading'>page_url</h4>
                            <span className='parameters_text'>URL of the page where ads will be displayed.</span>
                        </li>
                        <li>
                            <h4 className='parameters_heading'>w</h4>
                            <span className='parameters_text'>Video player width.</span>
                        </li>
                        <li>
                            <h4 className='parameters_heading'>h</h4>
                            <span className='parameters_text'>Video player height.</span>
                        </li>
                        <li>
                            <h4 className='parameters_heading'>startdelay</h4>
                            <span className='parameters_text'>Indicates the start delay in seconds for preroll, midroll, or postroll ad placement. If the start delay value is
                                greater than 0 then the position is mid-roll, and the value represents the number of seconds into the content that
                                the ad will be displayed. If the start delay time is not available, you can report the position of the ad in general terms
                                using negative numbers:
                                <br /> 0 - Pre-roll
                                <br /> -1 - Generic mid-roll
                                <br /> -2 - Generic Post-roll</span>
                        </li>
                        <li>
                            <h4 className='parameters_heading'>linearity</h4>
                            <span className='parameters_text'>Indicates the type of an ad impression: “linear”(default) and “overlay”.</span>
                        </li>
                        <li>
                            <h4 className='parameters_heading'>ip</h4>
                            <span className='parameters_text'>IP address of the visitor.</span>
                        </li>
                        <li>
                            <h4 className='parameters_heading'>ua</h4>
                            <span className='parameters_text'>User-Agent header from visitor's HTTP request.</span>
                        </li>
                        <li>
                            <h4 className='parameters_heading'>SSP_REDIR_URL</h4>
                            <span className='parameters_text'>Up to 128 alphanumeric and special characters is allowed: [0-9A-Za-z._-]. The zone is allowed to have up to 2,000 distinct subids per day. You will be able to view statistics for each subid.</span>
                        </li>
                        <li>
                            <h4 className='parameters_heading'>gdpr</h4>
                            <span className='parameters_text'>specifies if GDPR applies for current user (0 or 1).</span>
                        </li>
                        <li>
                            <h4 className='parameters_heading'>gdpr_consent</h4>
                            <span className='parameters_text'>URL-encoded Base64-encoded consent string as per IAB specification.</span>
                        </li>
                        <li>
                            <h4 className='parameters_heading'>us_privacy</h4>
                            <span className='parameters_text'>URL-encoded U.S. Privacy string.</span>
                        </li>
                    </ul>
                </div>
                {/* <label className='form_label'>US East(New York)</label>
                <div className="select_item">
                    <div className="primary text">
                        http://vid-rtb.xapads.com/rtb?zone=225098
                    </div>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div>
                <label className='form_label'>US East(New York)</label>
                <div className="select_item">
                    <div className="primary text">
                        http://vid-rtb.xapads.com/rtb?zone=225098
                    </div>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div>
                <label className='form_label'>US East(New York)</label>
                <div className="select_item">
                    <div className="primary text">
                        http://vid-rtb.xapads.com/rtb?zone=225098
                    </div>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div> */}
            </>
        )
    },
    {
        key: '2', tab: 'User Sync Tag',
        content: (
            <>
                <label className='form_label'>US East(New York)</label>
                <div className="select_item">
                    <div className="primary text">
                        http://vid-rtb.xapads.com/rtb?zone=225098
                    </div>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div>
                <label className='form_label'>US East(New York)</label>
                <div className="select_item">
                    <div className="dark text">
                        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Assumenda
                    </div>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div>
                <label className='form_label'>US East(New York)</label>
                <div className="select_item">
                    <div className="dark text">
                        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Assumenda
                    </div>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div>
                <label className='form_label'>US East(New York)</label>
                <div className="select_item">
                    <div className="primary text">
                        http://vid-rtb.xapads.com/rtb?zone=225098
                    </div>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div>
            </>
        )
    },
    {
        key: '3', tab: 'Link', content: (
            <>
                <label className='form_label'>US East(New York)</label>
                <div className="select_item">
                    <div className="primary text">
                        http://vid-rtb.xapads.com/rtb?zone=225098
                    </div>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div>
                <label className='form_label'>US East(New York)</label>
                <div className="select_item">
                    <div className="primary text">
                        http://vid-rtb.xapads.com/rtb?zone=225098
                    </div>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div>
                <label className='form_label'>US East(New York)</label>
                <div className="select_item">
                    <div className="primary text">
                        http://vid-rtb.xapads.com/rtb?zone=225098
                    </div>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div>
                <label className='form_label'>US East(New York)</label>
                <div className="select_item">
                    <div className="primary text">
                        http://vid-rtb.xapads.com/rtb?zone=225098
                    </div>
                    <Tooltip title="Click to copy">
                        <Link to="/"><img src={copyIcon} alt='Copy Icon' /></Link>
                    </Tooltip>
                </div>
            </>
        )
    },
];


const CustomOption = ({ value, label }) => (
    <div className="d-flex gap-10">
        <span>{value}</span><b>{label}</b>
    </div>
);
const { Option } = Select;

const options = [
    { value: 'USA', label: '+1' },
    { value: 'Pakistan', label: '+92' },
    { value: 'Germany', label: '+49' },
    { value: 'Kenya', label: '+254' },
    { value: 'Nigeria', label: '+234' },
];


const codeOptions = [
    { value: 'USA', label: '+1' },
    { value: 'Pakistan', label: '+92' },
    { value: 'Germany', label: '+49' },
    { value: 'Kenya', label: '+254' },
    { value: 'Nigeria', label: '+234' },
    { value: 'wdwdwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww', label: '+234' },
];



const optionsd2 = [];
for (let i = 10; i < 36; i++) {
    const valuee = i.toString(36) + i;
    options.push({
        label: `Long Label: ${valuee}`,
        valuee,
    });
}
const sharedProps = {
    mode: 'multiple',
    optionsd2,
    placeholder: 'Select Item...',
    maxTagCount: 'responsive',
};


function Components() {



    const [show, setShow] = useState(false);
    const dropdownRef = useRef(null);

    const handleToggle = () => setShow(!show);
    const handleClose = () => setShow(false);

    const handleApplyClick = () => {
        // Your apply logic here
        handleClose();
    };

    const handleResetClick = () => {
        // Your reset logic here
        handleClose();
    };


    const [valued2, setValued2] = useState(['a10', 'c12', 'h17', 'j19', 'k20']);
    const selectProps = {
        valued2 ,
        onChange: setValued2,
    };




    const [activeKey, setActiveKey] = useState('1');

    const onTabChange = (key) => {
        setActiveKey(key);
    };
    React.useEffect(() => {
        setTimeout(() => {
            const reactInput = document.getElementById('react-select-2-input')
            reactInput?.setAttribute("placeholder", "Search");
        }, 1500);
    })


    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            padding: 10,
            display: 'flex',
            alignItems: 'center',
        }),
    };

    const formatOptionLabel = ({ value, label }) => (
        <div className="d-flex gap-10">
            <span>{value}</span><b>{label}</b>
        </div>
    );
    const [selectedOption, setSelectedOption] = useState(null);

    const handleChange = option => {
        setSelectedOption(option);
    };
    const [value, setValue] = useState(1);
    const onChange = (e) => {
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
    };
    const onChangeSwitch = (checked) => {
        console.log(`switch to ${checked}`);
    };
    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    }, []);

    // Modal Start
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };
    //Modal End
    return (
        <>

            <div className="container_box mt-5 pt_header">

                <Row gutter={16} className='mb-5'>
                    <Col span={12}>
                        <div className="form_content_block--group">
                            <button type="primary" onClick={showModal}>
                                Open Modal
                            </button>
                            <Modal
                                className='custom_modal'
                                title={<div className='custom_modal--header --tabs'><h3 className='heading'><img src={zoneInfoIcon} alt='USP' /> Zone info</h3>
                                    <div className="tab_content--buttons">
                                        {items.map((item) => (
                                            <button
                                                key={item.key}
                                                onClick={() => onTabChange(item.key)}
                                                className={activeKey === item.key ? 'btn active' : 'btn'}
                                            >
                                                {item.tab}
                                            </button>
                                        ))}
                                    </div>
                                </div>}
                                visible={isModalVisible}
                                onOk={handleOk}
                                closable={false} // This removes the default close button
                                width={770}
                                footer={[
                                    <div className="custom_modal--footer d_flex justify_content_end">
                                        <button key="submit" className='btn btn_primary w_fit_content' onClick={handleOk}>
                                            Ok
                                        </button>
                                    </div>
                                ]}
                            >
                                <div className="custom_modal--body">
                                    <div className="tab_content--body">
                                        {items.map((item) => (
                                            <div
                                                key={item.key}
                                                style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                            >
                                                {item.content}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </Col>
                </Row>

                <Row gutter={16} className='mb-5'>
                    <Col span={12}>
                        <div className="form_content_block--group">
                            <ReactSelect
                                value={selectedOption}
                                onChange={handleChange}
                                options={codeOptions}
                                isSearchable={true}
                                // menuIsOpen={true}
                                // className="form_select basic"
                                classNamePrefix="form_select basic"
                                formatOptionLabel={formatOptionLabel}
                                styles={customStyles}
                                placeholder=""
                            />
                        </div>
                    </Col>
                    <Col span={12}>
                        <div className="form_content_block--group">
                            <div className='input_group'>
                                <ReactSelect
                                    value={selectedOption}
                                    onChange={handleChange}
                                    options={codeOptions}
                                    isSearchable={true}
                                    // menuIsOpen={true}
                                    // className="form_select basic"
                                    classNamePrefix="form_select basic"
                                    formatOptionLabel={formatOptionLabel}
                                    styles={customStyles}
                                    placeholder=""
                                    dropdownStyle={{
                                        width: '34.4rem'
                                    }} // Set the custom width for the dropdown
                                />
                                <Input defaultValue="" className='form_control' />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={24}>
                        <div className="form_content_block--group">
                            <label for='fileUploader' className='ant_upload_drag'>
                                <p className="upload_drag_icon">
                                    <img src={uploadIcon} alt='USP' />
                                </p>
                                <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                                <p className="ant_upload_hint">
                                    PPT (max. 100 MB)
                                </p>
                            </label>
                            <input className='form_upload d-none' type="file" id="fileUploader" name="fileUploader" />

                            <div class="ant_upload_list--item">
                                <div class="ant_upload_list--content">
                                    <img src={pptIcon} alt="USP" />
                                    <div class="ant_upload_list--info">
                                        <span class="ant_upload_list--info-name">84x84.jpg</span>
                                        <span class="ant_upload_list--info-size">0.01 MB</span>
                                    </div>
                                </div>
                                <button type="link" class="ant_upload_list--delete">
                                    <img src={deleteIcon} alt="USP" />
                                </button>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group position-relative">
                            <Space.Compact className='form_compact basic'>
                                <Select
                                    className='form_select'
                                    optionLabelProp="label"
                                    // open="true"
                                    dropdownStyle={{
                                        width: '34.4rem'
                                    }} // Set the custom width for the dropdown
                                >
                                    {
                                        options.map((option) => (
                                            <Option key={option.value} value={option.value} label={option.label}>
                                                <CustomOption value={option.value} label={option.label} />
                                            </Option>
                                        ))
                                    }
                                </Select>
                                <Input defaultValue="Xihu District, Hangzhou" className='form_control' />
                            </Space.Compact>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Single Select</label>
                            <Switch defaultChecked onChange={onChangeSwitch} />

                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="google_ads_design_d2 form_content_block--group">
                            <div className='d-flex align-items-center justify-content-between'>
                                <div className='d-flex align-items-center'>
                                    <img src={googleImg} className='img-fluid' alt="" />
                                    <label className='form_label'>Google Ads Manager</label>
                                </div>
                                <Switch defaultChecked onChange={onChangeSwitch} />
                            </div>
                            <div className="form_content_block--group mt_d2_24">
                                <Input className='form_control basic' placeholder="Enter Network ID" />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group hide_caret_after_select_value">
                            <label className='form_label'>Single Select with no search</label>
                            <Select
                                showSearch
                                // open={true}
                                optionFilterProp="label"
                                className='form_select basic no_search'
                                options={[
                                    {
                                        value: 'one',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'tow',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'three',
                                        label: 'Loreum Ipsum',
                                    },
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Single Select</label>
                            <Radio.Group onChange={onChange} value={value}>
                                <Radio className='custom-radio' value={1}>Publisher</Radio>
                                <Radio className='custom-radio' value={2}>Publisher</Radio>
                                <Radio className='custom-radio' value={3}>Publisher</Radio>
                                <Radio className='custom-radio' value={4}>Publisher</Radio>
                            </Radio.Group>
                        </div>
                    </Col>
                </Row>
                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group hide_caret_after_select_value">
                            <label className='form_label'>Single Select</label>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                className='form_select basic'
                                options={[
                                    {
                                        value: 'one',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'tow',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'three',
                                        label: 'Loreum Ipsum',
                                    },
                                ]}
                            />
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group hide_caret_after_select_value">
                            <label className='form_label'>Single Select</label>
                            <Select
                                showSearch
                                optionFilterProp="label"
                                className='form_select basic error'
                                options={[
                                    {
                                        value: 'one',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'tow',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'three',
                                        label: 'Loreum Ipsum',
                                    },
                                ]}
                            />
                            <span className='error_content'>Please enter valid Name</span>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group hide_caret_after_select_value">
                            <label className='form_label'>Single Select</label>

                            <Select
                                showSearch
                                optionFilterProp="label"
                                // open={true}
                                className='form_select basic'
                                options={[
                                    {
                                        value: 'one',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'tow',
                                        label: 'Loreum Ipsum',
                                    },
                                    {
                                        value: 'three',
                                        label: 'Loreum Ipsum',
                                    },
                                ]}
                            />
                        </div>
                    </Col>
                </Row>

                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Input</label>
                            <Input
                                className='form_control basic'
                                placeholder="Enter your Full Name"
                            />
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Input with icon</label>
                            <Input className='form_control form_control_with_icon_d2 basic' placeholder="Enter your Full Name" suffix={'%'} />
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Error</label>
                            <Input
                                className='form_control basic error'
                                placeholder="Enter your Full Name"
                            />
                            <span className='error_content'>Please enter valid Name</span>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Disabled</label>
                            <Input
                                className='form_control basic'
                                placeholder="Enter your Full Name"
                                disabled
                                value={100}
                            />
                        </div>
                    </Col>

                </Row>

                <Row gutter={16} className='mb-5'>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Button Primary</label>
                            <button className='btn_primary btn'>
                                <span>SUBMIT</span>
                            </button>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Button Primary</label>
                            <button className='btn_primary btn'>
                                <span>SUBMIT</span>
                            </button>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Button Primary</label>
                            <button className='btn_primary btn' disabled>
                                <span>SUBMIT</span>
                            </button>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="form_content_block--group">
                            <label className='form_label'>Button Primary</label>
                            <button className='btn_primary btn loader'>
                                <span>SUBMIT</span>
                                <img src={loaderIcon} alt='USP' className='loader_icon' />
                            </button>
                        </div>
                    </Col>

                    <Col span={6}>

                        <div className="custom_filter_design_d2">

                            <div className="filter_tags_design_d2">
                                <ul className="p-0 m-0">
                                    <li>
                                        <div className="d-flex">
                                            <span className="black_text_d2">Zone Category:</span> OpenRTB, Prebid
                                        </div>
                                        <button type="button"><img src={tagRomoveIcon} className="" alt="" /> </button>
                                    </li>
                                    <li>
                                        <div className="d-flex">
                                            <span className="black_text_d2">Zone Category:</span> OpenRTB, Prebid
                                        </div>
                                        <button type="button"><img src={tagRomoveIcon} className="" alt="" /> </button>
                                    </li>
                                </ul>
                            </div>

                            <Dropdown ref={dropdownRef} show={show} onToggle={handleToggle} className="" autoClose={false}>
                                <Dropdown.Toggle id="dropdown-autoclose-false">
                                    <img src={filterIcon} className="img-fluid" alt="" /> Filter <span className="selected_filter_tag_d2">
                                        <div>3</div>
                                        <button type="button"> <img src={HoverCloseIcon} alt="" /> </button>
                                    </span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                    <div className="filter_inner_heading_d2">
                                        <p className="m-0">Status</p>
                                        <div className="radio_value_select_d2">
                                            <div className="radio_active_design_d2">
                                                <input type="radio" name="one" id="one" />
                                                <label htmlFor="" className="single_radio_select_d2">
                                                    Enabled
                                                </label>
                                            </div>
                                            <div className="radio_active_design_d2">
                                                <input type="radio" name="one" id="one" />
                                                <label htmlFor="" className="single_radio_select_d2">
                                                    Enabled
                                                </label>
                                            </div>
                                            <div className="radio_active_design_d2">
                                                <input type="radio" name="one" id="one" />
                                                <label htmlFor="" className="single_radio_select_d2">
                                                    Enabled
                                                </label>
                                            </div>
                                            <div className="radio_active_design_d2">
                                                <input type="radio" name="one" id="one" />
                                                <label htmlFor="" className="single_radio_select_d2">
                                                    Enabled
                                                </label>
                                            </div>
                                            <div className="radio_active_design_d2">
                                                <input type="radio" name="one" id="two" />
                                                <label htmlFor="" className="single_radio_select_d2">
                                                    Disabled
                                                </label>
                                            </div>
                                        </div>
                                        <hr />

                                        <p className="m-0">Zone Category</p>
                                        <div className="checkbox_value_select_d2">
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="one" id="one" />
                                                <label htmlFor="" className="single_checkbox_select_d2">
                                                    OpenRTB
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="one" id="one" />
                                                <label htmlFor="" className="single_checkbox_select_d2">
                                                    Prebid
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="one" id="one" />
                                                <label htmlFor="" className="single_checkbox_select_d2">
                                                    VAST
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="one" id="one" />
                                                <label htmlFor="" className="single_checkbox_select_d2">
                                                    GAM Tag
                                                </label>
                                            </div>
                                            <div className="checkbox_active_design_d2">
                                                <input type="checkbox" name="one" id="two" />
                                                <label htmlFor="" className="single_checkbox_select_d2">
                                                    Player Tag
                                                </label>
                                            </div>
                                        </div>
                                        <hr />

                                        <p className="m-0">ADCODE</p>
                                        <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">
                                            <Select {...sharedProps} {...selectProps} defaultOpen={false} className="form_select basic error" />
                                        </div>
                                        <hr />
                                    </div>
                                    <div className="filter_bottom_btns_d2 text-end">
                                        <button className="reset" type='button' onClick={handleResetClick}>Reset</button>
                                        <button className="apply" type='button' onClick={handleApplyClick}>Apply</button>
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </Col>

                </Row>
            </div >

        </>
    )
}

export default Components;